import { useEffect, useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useLocation } from 'react-router-dom';

import { TabContextKeys } from './mappings/activeTabContext';
import { mapSidebarAccessHub } from './mappings/sidebarAccessHub';
import { getMapSidebarItems } from './mappings/sidebarItems';
import { mapSidebarMarketplace } from './mappings/sidebarMarketplace';
import { enableCopilot } from './mappings/tabsEnables';
import * as S from './styles';
import Cockpit from 'components/Helper/Cockpit';
import { UnderConstruction } from 'components/Helper/UnderConstruction';
import useOnClickOutside from 'components/Helper/utils/useOnClickOutsideFilter';
import Text from 'components/Text';
import { useDrawerState } from 'global/DrawerContext';
import { useMenu } from 'global/MenuContext';
import { useTab } from 'global/TabContext';
import usePlanType from 'hooks/usePlanType';
import AdvisorsAccessHub from 'microfrontends/Advisors/AccessHub/Advisors';
import ScheduledAdvisorCalls from 'microfrontends/Advisors/ScheduledAdvisorCalls';
import ScheduledCalls from 'microfrontends/Advisors/ScheduledCalls';
import TimerDisplay from 'microfrontends/components/TimeDisplay';
import useActiveMeetingTimer from 'microfrontends/hooks/useActiveMeetingTimer';
import useMeetingDetails from 'microfrontends/hooks/useMeetingDetails';
import AdvisorsMarketplace from 'microfrontends/Marketplace/Advisors';
import GeneralMarketplace from 'microfrontends/Marketplace/General';
import ServicesMarketplace from 'microfrontends/Marketplace/Services';
import theme from 'styles/theme';
import {
  IconAccessHub,
  IconAccessHubYellow,
  IconCoin,
  IconFilter,
  IconHelpDeskAdvisor,
  IconMarketplace,
  IconMarketplaceYellow,
} from 'utils/utilsIcons';

interface IFilter {
  onClick: () => void;
  open: boolean;
  currentPath: string;
  onActiveFilterChange: (activeItem: any) => void;
  payloadData?: any;
}

const Filter = ({
  onClick,
  open,
  currentPath = '',
  onActiveFilterChange,
  onTranslateXChange,
  payloadData,
}: IFilter & { onTranslateXChange: (value: string) => void }) => {
  const location = useLocation();
  const { planType, isAdvisor } = usePlanType();
  const { activeTabContext } = useTab() as {
    activeTabContext: keyof typeof enableCopilot;
  };
  const {
    isOpenMenus,
    setIsOpenMenus,
    openDrawer,
    setOpenDrawer,
    openDrawerFilter,
    setOpenDrawerFilter,
    setOpenDrawerCopilot,
    openDrawerAdvisor,
    openDrawerMentorship,
    setOpenDrawerAdvisor,
    openDrawerScheduledCalls,
    activeFilter,
    setActiveFilter,
    translateXDrawerFilters,
    setTranslateXDrawerFilters,
    openDrawerAccessHub,
    setOpenDrawerAccessHub,
    openDrawerMarketplace,
    setOpenDrawerMarketplace,
    handleOpenMenus,
    handleOpenDrawerAdvisor,
    handleOpenDrawerMentorship,
    handleActiveFilter,
    handleActiveAdvisor,
    handleActiveMentorship,
    handleActiveMarketplace,
    handleActiveAccessHub,
    handleOpenDrawerScheduledCalls,
    handleOpenDrawerAccessHub,
    handleOpenDrawerMarketplace,
  } = useDrawerState();

  const menuRef = useRef(null);
  const drawerRef = useRef(null);

  const { sideMenu } = useMenu();

  const [disabledButtons, setDisabledButtons] = useState({
    advisor: false,
    dataCuration: false,
    virtualTeam: false,
  });

  const mapSidebarItems = getMapSidebarItems(activeTabContext as TabContextKeys, location.pathname);

  useOnClickOutside(
    drawerRef,
    () => {
      setIsOpenMenus(false);
      setOpenDrawer(false);
      setOpenDrawerFilter(false);
      setOpenDrawerCopilot(false);
      setOpenDrawerAdvisor(false);
      setActiveFilter(null);
      setTranslateXDrawerFilters('0px');
      onTranslateXChange('0px');
    },
    openDrawer,
    openDrawerFilter
  );

  const handleMenuClick = (action: () => void) => {
    action();
    handleOpenMenus();
  };

  const { meetingDetails, isLoading: isLoadingMeetingsDetails, refetch } = useMeetingDetails();
  const { remainingTime, isMeetingActive } = useActiveMeetingTimer(meetingDetails);

  const handleInteraction = () => {
    // refetch();
  };

  useEffect(() => {
    if (openDrawer) {
      // refetch();
    }
  }, [openDrawer, refetch]);

  const hasBigButon =
    sideMenu?.solutions?.services ||
    sideMenu?.solutions?.advisors ||
    sideMenu?.solutions?.courses ||
    sideMenu?.solutions?.plans ||
    sideMenu?.solutions?.icon;

  const hasSolutions =
    sideMenu?.solutions?.services ||
    sideMenu?.solutions?.advisors ||
    sideMenu?.solutions?.courses ||
    sideMenu?.solutions?.plans;
  return (
    <>
      {sideMenu?.timer && (
        <S.Timer ref={drawerRef} pixelsDrawer={translateXDrawerFilters} drawerOpen={openDrawer}>
          {isMeetingActive ? (
            <TimerDisplay
              time={remainingTime}
              onClick={() => {
                handleOpenDrawerScheduledCalls();
              }}
            />
          ) : (
            <TimerDisplay time={null} />
          )}
        </S.Timer>
      )}

      {sideMenu?.coins && (
        <S.Coin ref={drawerRef} pixelsDrawer={translateXDrawerFilters} drawerOpen={openDrawer}>
          <IconCoin />
        </S.Coin>
      )}

      {hasBigButon && (
        <S.FilterButton
          ref={drawerRef}
          onClick={() => {
            handleOpenMenus();
            handleInteraction();
          }}
          pixelsDrawer={translateXDrawerFilters}
          drawerOpen={openDrawer}
        >
          {sideMenu?.solutions?.icon?.url ? (
            <img src={sideMenu.solutions.icon.url} alt="Menu Icon" style={{ width: '2rem' }} />
          ) : (
            <GiHamburgerMenu size="32px" color={theme.COLORS.WHITE_3} />
          )}
          <S.FilterTitle>{sideMenu?.solutions?.label || 'Menu'}</S.FilterTitle>
        </S.FilterButton>
      )}

      {hasSolutions && (
        <AnimatePresence>
          {isOpenMenus && !openDrawer && (
            <S.MenuContainer
              ref={menuRef}
              initial={{ opacity: 0, rotateX: -90 }}
              animate={{ opacity: 1, rotateX: 0 }}
              exit={{ opacity: 0, rotateX: -90 }}
              transition={{ duration: 0.5 }}
            >
              {hasSolutions && (
                <S.MenuItem
                  onClick={() => handleMenuClick(handleOpenDrawerMarketplace)}
                  initial={{ opacity: 0, rotateX: -90 }}
                  animate={{ opacity: 1, rotateX: 0 }}
                  exit={{ opacity: 0, rotateX: -90 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                >
                  <S.FilterButtonCopilot
                    drawerOpen={openDrawer}
                    className="z-index"
                    pixelsDrawer={translateXDrawerFilters}
                    disabled={disabledButtons.advisor}
                  >
                    <img src={IconMarketplace} alt="Marketplace icone" style={{ width: '2rem' }} />
                    <S.FilterTitleCopilot disabled={disabledButtons.advisor}>
                      <Text
                        size="xSmall"
                        textAlign="center"
                        onClick={() => handleMenuClick(handleOpenDrawerMarketplace)}
                      >
                        Soluções
                      </Text>
                    </S.FilterTitleCopilot>
                  </S.FilterButtonCopilot>
                </S.MenuItem>
              )}

              {sideMenu?.solutions?.advisors && (
                <S.MenuItem
                  onClick={() => handleMenuClick(handleOpenDrawerAccessHub)}
                  initial={{ opacity: 0, rotateX: -90 }}
                  animate={{ opacity: 1, rotateX: 0 }}
                  exit={{ opacity: 0, rotateX: -90 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  <S.FilterButtonCopilotCenter
                    drawerOpen={openDrawer}
                    className="z-index"
                    isForward
                    pixelsDrawer={translateXDrawerFilters}
                    disabled={disabledButtons.advisor}
                  >
                    <img src={IconAccessHub} alt="Hub de acesso icone" style={{ width: '2rem' }} />

                    <S.FilterTitleCopilot disabled={disabledButtons.advisor}>
                      Hub de acesso
                    </S.FilterTitleCopilot>
                  </S.FilterButtonCopilotCenter>
                </S.MenuItem>
              )}

              {sideMenu?.solutions?.advisors && (
                <S.MenuItem
                  onClick={() => handleOpenDrawerScheduledCalls()}
                  initial={{ opacity: 0, rotateX: -90 }}
                  animate={{ opacity: 1, rotateX: 0 }}
                  exit={{ opacity: 0, rotateX: -90 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                >
                  <S.FilterButtonCopilot
                    drawerOpen={openDrawer}
                    pixelsDrawer={translateXDrawerFilters}
                    disabled={disabledButtons.dataCuration}
                    className="z-index"
                  >
                    <IconHelpDeskAdvisor />
                    <S.FilterTitleCopilot disabled={disabledButtons.dataCuration}>
                      Chamadas Agendadas
                    </S.FilterTitleCopilot>
                  </S.FilterButtonCopilot>
                </S.MenuItem>
              )}
            </S.MenuContainer>
          )}
        </AnimatePresence>
      )}

      {openDrawer && (
        <S.DrawerMain ref={drawerRef}>
          {openDrawerAccessHub && (
            <S.HeaderMenuAdvisor>
              <img src={IconAccessHubYellow} alt="Access Hub Icon" style={{ width: '1rem' }} />
              <Text color="primary" size="xSmall">
                Hub de acesso
              </Text>
            </S.HeaderMenuAdvisor>
          )}
          {openDrawerMarketplace && (
            <S.HeaderMenuAdvisor>
              <img src={IconMarketplaceYellow} alt="Soluções Icon" style={{ width: '1rem' }} />
              <Text color="primary" size="xSmall">
                Soluções
              </Text>
            </S.HeaderMenuAdvisor>
          )}

          <S.DrawerContainer>
            <S.SidebarContainer>
              {openDrawer &&
                openDrawerFilter &&
                mapSidebarItems.map(item => (
                  <S.SidebarButton
                    key={item.name}
                    active={activeFilter?.name === item.name}
                    onClick={() => handleActiveFilter(item, () => null)}
                    disabled={(!!item.path && item.path !== currentPath) || !item.enabled}
                  >
                    <S.IconContainer>
                      <item.icon color="white" />
                      {item.filter && (
                        <IconFilter width="10px" height="10px" color={theme.COLORS.PRIMARY} />
                      )}
                    </S.IconContainer>
                    <S.ButtonTitle>{item.name}</S.ButtonTitle>
                  </S.SidebarButton>
                ))}

              {openDrawer &&
                openDrawerAccessHub &&
                mapSidebarAccessHub.map((item: any) => (
                  <S.SidebarButtonCopilot
                    key={item.name}
                    active={activeFilter?.name === item.name}
                    onClick={() => handleActiveAccessHub(item)}
                    disabled={item.disabled}
                  >
                    <S.IconContainer>
                      <item.icon color="white" />
                    </S.IconContainer>
                    <S.ButtonTitle>{item.name}</S.ButtonTitle>
                  </S.SidebarButtonCopilot>
                ))}

              {openDrawer &&
                openDrawerMarketplace &&
                sideMenu &&
                mapSidebarMarketplace(sideMenu).map((item: any) => {
                  if (item.disabled) {
                    return null;
                  }
                  return (
                    <S.SidebarButtonCopilot
                      key={item.name}
                      active={activeFilter?.name === item.name}
                      onClick={() => handleActiveMarketplace(item)}
                      disabled={item.disabled}
                    >
                      <S.IconContainer>
                        <item.icon color="white" />
                      </S.IconContainer>
                      <S.ButtonTitle>{item.name}</S.ButtonTitle>
                    </S.SidebarButtonCopilot>
                  );
                })}
            </S.SidebarContainer>
          </S.DrawerContainer>

          <AnimatePresence>
            {activeFilter && openDrawer && openDrawerFilter && (
              <S.ContentFilter>
                <S.BoxContent
                  key={activeFilter.name}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.5 }}
                >
                  <S.Heading>{activeFilter?.name}</S.Heading>
                  {activeFilter?.name === 'Redes Sociais Cockpit' && <Cockpit />}
                  {activeFilter?.name === 'Wizard Dados' && <UnderConstruction />}
                  {activeFilter?.name === 'Bloco de notas' && <UnderConstruction />}
                  {activeFilter?.name === 'Onboarding' && <UnderConstruction />}
                </S.BoxContent>
              </S.ContentFilter>
            )}

            {activeFilter && openDrawer && openDrawerMarketplace && (
              <S.ContentAdvisor>
                <S.BoxContent>
                  <Text size="medium" color="yellow" bold>
                    {activeFilter.name}
                  </Text>
                  {activeFilter.name === 'Cursos' && <GeneralMarketplace categoryId={1} />}
                  {activeFilter.name === 'Mentores' && sideMenu?.solutions?.advisors && (
                    <AdvisorsMarketplace />
                  )}
                  {activeFilter.name === 'Planos' && <GeneralMarketplace categoryId={5} />}
                  {activeFilter.name === 'Serviços' && <ServicesMarketplace />}
                </S.BoxContent>
              </S.ContentAdvisor>
            )}

            {activeFilter && openDrawer && openDrawerAccessHub && (
              <S.ContentAdvisor>
                <S.BoxContent>
                  <Text size="medium" color="yellow" bold>
                    {activeFilter.name}
                  </Text>
                  {activeFilter.name === 'Mentores' && <AdvisorsAccessHub />}
                </S.BoxContent>
              </S.ContentAdvisor>
            )}

            {activeFilter && openDrawer && openDrawerScheduledCalls && (
              <S.ContentAdvisor>
                <S.BoxContent>
                  <Text size="medium" color="yellow" bold>
                    {activeFilter.name}
                  </Text>
                  {activeFilter.name === 'Chamadas Agendadas' &&
                    (isAdvisor ? <ScheduledAdvisorCalls /> : <ScheduledCalls />)}
                </S.BoxContent>
              </S.ContentAdvisor>
            )}
          </AnimatePresence>
        </S.DrawerMain>
      )}
    </>
  );
};

export default Filter;
